import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: ['id', 'dstyle'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;
const showModal = ref(false);

const viewModal = () => {
};
const close = (app) => {
	showModal.value = false;
	jQuery("html").removeClass("modalOpen");
};



const __returned__ = { props, showModal, viewModal, close }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})